(function () {
  function init() {
    var els = document.querySelectorAll('.pg-rv:not([data-rv])');
    if (!els.length) return;
    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      els.forEach(function (el) { el.setAttribute('data-rv', 'in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var el = e.target;
        var group = el.closest('[data-rv-group]');
        var delay = 0;
        if (group) {
          var sibs = Array.prototype.slice.call(group.querySelectorAll('.pg-rv'));
          delay = Math.min(sibs.indexOf(el), 7) * 70;
        }
        setTimeout(function () { el.setAttribute('data-rv', 'in'); }, delay);
        io.unobserve(el);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });
    els.forEach(function (el) { el.setAttribute('data-rv', 'out'); io.observe(el); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
